import React, { ReactNode } from "react";
import { Flex, Text } from "@chakra-ui/react";
import { ORDER_DETAIL_CARD_SX } from "@/features/pathpick/features/order-history/features/detail/constants";

interface Props {
  title?: string;
  // 타이틀 행 오른쪽에 붙는 보조 정보(예: 상품 개수, 배송 건수 요약)
  headerRight?: ReactNode;
  gap?: string;
  children: ReactNode;
}

// 주문 상세의 모든 섹션이 공유하는 카드 셸.
function PathPickOrderDetailCard({
  title,
  headerRight,
  gap = "16px",
  children,
}: Props) {
  return (
    <Flex
      flexDirection={"column"}
      gap={gap}
      padding={"16px"}
      sx={ORDER_DETAIL_CARD_SX}
    >
      {(title || headerRight) && (
        <Flex
          justifyContent={"space-between"}
          alignItems={"center"}
          gap={"8px"}
        >
          <Text textStyle={"body-md-bold"} color={"#1D1D1B"}>
            {title}
          </Text>
          {headerRight}
        </Flex>
      )}
      {children}
    </Flex>
  );
}

export default PathPickOrderDetailCard;
